import { render, staticRenderFns } from "./Dqgy.vue?vue&type=template&id=2b572456&scoped=true&"
import script from "./Dqgy.vue?vue&type=script&lang=js&"
export * from "./Dqgy.vue?vue&type=script&lang=js&"
import style0 from "./Dqgy.vue?vue&type=style&index=0&id=2b572456&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b572456",
  null
  
)

export default component.exports